import { Sparkles } from "lucide-react";
import { LOGO } from "@/config/images";

export const Seal = ({ size = 44 }) => (
  <img src={LOGO.web} alt="Goddess University" width={size} height={size} className="object-contain shrink-0" style={{ width: size, height: size }} data-testid="gu-logo" />
);

export const BrandHeader = ({ onHome }) => (
  <header className="no-print px-5 sm:px-10 py-5 flex items-center justify-between max-w-6xl mx-auto">
    <button
      data-testid="brand-home-link"
      onClick={onHome || undefined}
      className={`flex items-center gap-3 text-left ${onHome ? "cursor-pointer" : "cursor-default"}`}
    >
      <Seal size={48} />
      <div>
        <div className="font-serif-display text-lg sm:text-xl text-[#4A2A20] leading-none">Goddess University</div>
        <div className="text-[10px] tracking-[0.28em] uppercase text-[#B8892F] mt-1">Journey Assessment</div>
      </div>
    </button>
    <div className="hidden sm:flex items-center gap-2 text-xs text-[#7D5A4B]">
      <Sparkles className="w-3.5 h-3.5 text-[#C9A24A]" />
      Founded by Rev. Goddess LaMeel
    </div>
  </header>
);

export const Overline = ({ children, className = "" }) => (
  <div className={`text-[11px] tracking-[0.28em] uppercase text-[#B8892F] font-semibold ${className}`}>{children}</div>
);

export const Ornament = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className="h-px w-10 bg-gradient-to-r from-transparent to-[#C9A24A]" />
    <span className="w-1.5 h-1.5 rotate-45 bg-[#C9A24A]" />
    <span className="h-px w-10 bg-gradient-to-l from-transparent to-[#C9A24A]" />
  </div>
);
